<template>
  <div>
    <v-row class="bradcrumb">
      <router-link :to="{ name: 'role-links' }" class="root">
        Dashboard
      </router-link>
      <span class="child">/ Import Learner For Re-Exam </span>
    </v-row>
    <br />
    <v-card class="card">
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-card-title class="heading">1:Deactive Student</v-card-title>
      <v-card class="box">
                      <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
        <v-card-text>
            <v-row justify="center">
                <v-col cols="3">
                    <label>Academic Year</label>
                    <v-select
                        v-model="current_academic_year"
                        :items="aylist"
                        item-text="ay"
                        item-value="id"
                        persistent-hint
                        return-object
                        outlined
                        dense
                    ></v-select>
                </v-col>
                <v-col cols="3">
                    <label>Semester</label>
                    <v-select
                        v-model="current_semester"
                        :items="semlist"
                        item-text="sem"
                        item-value="id"
                        persistent-hint
                        return-object
                        outlined
                        dense
                    ></v-select>
                </v-col>
            
           
                <v-col cols="3" class="mt-5">
                 <v-btn @click="deactivestd()" :loading="output_load" class="button">
                Deactive
               
              </v-btn>
                </v-col>
          </v-row>
          
        </v-card-text>
      </v-card>
    </v-card>
    <v-card class="card mt-2">
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-card-title class="heading">2:Import Learner For Re-Exam </v-card-title>
      <v-card class="box">
        <div class="flex">
          <div></div>
          <div>
            <a
              href="https://easypariksha.s3.ap-south-1.amazonaws.com/import_excel_csv_file/LearnerReexam_Sample_File.csv"
            >
              <v-btn
                :loading="loading3"
                :disabled="loading3"
                color="success"
                class="ma-2 white--text downbtn"
                @click="loader = 'loading3'"
              >
                <v-icon left dark>mdi-cloud-download</v-icon>Download import CSV
                format
              </v-btn>
            </a>
          </div>
        </div>
        <v-card-text>
            <v-row justify="center">
                <v-col cols="3">
                    <label>Academic Year</label>
                    <v-select
                        v-model="current_academic_year"
                        :items="aylist"
                        item-text="ay"
                        item-value="id"
                        persistent-hint
                        return-object
                        outlined
                        dense
                    ></v-select>
                </v-col>
                <v-col cols="3">
                    <label>Semester</label>
                    <v-select
                        v-model="current_semester"
                        :items="semlist"
                        item-text="sem"
                        item-value="id"
                        persistent-hint
                        return-object
                        outlined
                        dense
                    ></v-select>
                </v-col>
                  <v-col cols="5" class="mt-3">
                     <v-file-input
                    v-model="file"
                    :hint="file != null ? '' : 'Please Select File'"
                    persistent-hint
                    color="rgb(1, 127, 152)"
                    label="Choose File"
                    accept=".csv"
                    prepend-icon="mdi-paperclip"
                    outlined
                    show-size
                >
                </v-file-input>
                  </v-col>
            </v-row>
          
          <v-row>
            <v-col cols="12" sm="12" align="center">
              <v-btn @click="submitFile" :loading="output_load" class="button">
                Upload
                <v-icon right>mdi-cloud-upload</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      table_: {
        Proctor: "empid",
        Learner: "grno",
        Remark: "reason",
      },
      dialog_send: false,
      dialog_faildata: false,
      examid: null,
      export_table_headers: {
        "Sr.No.": "srno",
        Proctor: "proctor",
        Learner: "learner",
        Exam: "exam",
      },
      headers: [
        { text: "Sr.no", value: "srno" },
        { text: "Proctor", value: "proctor" },
        { text: "Learner", value: "learner" },
        { text: "Exam", value: "exam" },
        { text: "Is-active", value: "isactive" },
        { text: "Action", value: "edit" },
      ],
      dialog_faildata: false,
      overlay:false,
      current_academic_year: "",
      current_semester: "",
      failList: [],
      aylist:[],
      semlist:[],
      file: null,
      loading3: false,
      search: "",
      dialog: false,
      editDialog: false,
      examList: [],
      learnerList: [],
      instList: [],
      dataList: [],
      snackbar_msg: "",
      color: "",
      snackbar: false,
      defaultItem: {
        examid: null,
        instid: null,
        lerid: null,
      },
      editedItem: {
        examid: null,
        instid: null,
        lerid: null,
        plmid: null,
        isactive: null,
      },
    };
  },

  mounted() {
    this.onLoad();
  },
  methods: {
    deactivestd(){
      this.overlay = true
       const data = {
                       ay:this.current_academic_year.ayid,
                         sem  :this.current_semester.semid
                                
                    };
                    axios
                        .post("/AdminImport/subRegDeactive", data)
                        .then((res) => {
                            this.dialog_add = false;
                            if (res.data.status == "YES") {
                                this.showSnackbar("#4CAF50", "Student Deactived successfully...");
                                this.overlay = false
                                //this.showSnackbar("#4CAF50","Course Authority status added successfully...")
                            } else if (res.data.status == "NO") {
                                this.showSnackbar("#b71c1c", " Already Deactived !!!");
                            }

                            this.onLoad();
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        })
                        .finally(() => {
                                this.overlay = false
                        });
      
    },
    submitFile() {
      if (this.file == null) {
        this.showSnackbar("#b71c1c", "Please select the CSV file!"); // show snackbar
      } else {
        this.dialog_send = true;
        let formData = new FormData();
        
        formData.append("file", this.file);
        formData.append("ayid", this.current_academic_year.ayid);
         formData.append("semid", this.current_semester.semid);
        axios
          .post("AdminImport/importLearnerReexam", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            if (res.data.msg == "200") {
              this.dialog_send = false;
              this.failList = res.data.dataInvalid;
              if(this.failList.length!=0){
                this.dialog_faildata = true;
              }
              this.examid = null;
              this.file = null;
              this.showSnackbar(
                "#4caf50",
                "Subject  Reexam Registration Imported successfully..."
              );
             // this.onLoad();
            }
          })
          .catch(function() {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            window.console.log(error);
          })
          .finally(() => {
            this.output_load = false;
          });
        //     }
      }
    }, //end of the fuction
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onLoad() {
      axios
        .post("/AdminImport/findAySem")
        .then((res) => {
          if (res.data.msg == "200") {
           
              this.aylist = res.data.aylist;
              this.semlist = res.data.semlist;
              this.current_academic_year = res.data.current_ay;
              this.current_semester = res.data.current_sem;
            // this.instList = res.data.int_list;
            // this.learnerList = res.data.lear_list;
            // this.examList = res.data.examlist;
            // this.dataList = res.data.allplm;
          } else {
            this.showSnackbar("#b71c1c", "Data not found...");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar on failure
          window.console.log(error);
        })
        .finally(() => {
          //close loader
        });
    },
    },
};
</script>

<style scoped>
.downbtn {
  float: right;
}
.box {
  background-color: #add8e630;
  margin: 8px !important;
  padding: 8px;
}
.flex {
  display: flex;
  justify-content: space-between;
}
@media only screen and (max-width: 600px) {
  .flex {
    display: block;
  }
}
.btn {
  margin: 1rem;
  padding-top: 1rem;
}
</style>
